<template>
    <div class="english-container">
  
      <h1>Snelstart</h1>
  
      <h2>Android:</h2>
  
      <ol>
        <li>
          Schakel de smartcard in.
          Wacht tot de pop-up verschijnt.
          Als de pop-up niet verschijnt,
          volg dan de onderstaande stappen.
        </li>
  
        <li>
          Open Instellingen, ga naar “Google”
          en tik vervolgens op “Alle services”.
        </li>
  
        <li>
          Selecteer in het menu
          “Verbonden apparaten en delen”
          de optie “Apparaten”.
        </li>
  
        <li>
          Schakel “Scannen naar apparaten in de buurt” in.
        </li>
  
        <li>
          De smartcard verschijnt in de lijst
          met beschikbare apparaten in de buurt.
        </li>
  
        <li>
          Tik op het apparaat
          en volg de instructies op het scherm
          om de verbinding te voltooien.
        </li>
      </ol>
  
      <div class="divider"></div>
  
      <h2>Zoeken in de buurt</h2>
  
      <p>
        Open de app “Google Find Hub”,
        selecteer uw smartcard
        en tik op “Geluid afspelen”
        om uw apparaat te lokaliseren.
        Zodra u het apparaat hebt gevonden,
        tikt u op “Geluid stoppen”.
      </p>
  
      <h2>Zoeken op afstand</h2>
  
      <p>
        Open de app “Google Find Hub”,
        selecteer uw smartcard
        en tik op het apparaat
        om de locatie te bekijken.
      </p>
  
      <p>
        Tik op “Routebeschrijving”
        om navigatie naar de locatie te openen.
      </p>
  
      <div class="divider"></div>
  
      <h1>Resetten</h1>
  
      <ol>
        <li>
          Open de app “Google Find Hub”,
          selecteer uw smartcard,
          tik op de instellingenknop,
          kies vervolgens
          “Verwijderen uit Find Hub”
          en bevestig.
        </li>
  
        <li>
          Wanneer het apparaat is ingeschakeld,
          drukt u vijf keer achter elkaar op de knop.
          Houd bij de vijfde keer de knop ingedrukt
          totdat u een geluidssignaal hoort.
        </li>
      </ol>
  
      <p class="remark">
        Opmerking:
        Zorg ervoor dat de smartcard is ingeschakeld
        en verwijderd uit de app
        “Google Find Hub”
        voordat u reset.
      </p>
  
      <div class="divider"></div>
  
      <h1>Fast Pair Instructies</h1>
  
      <h2>Smartcard toevoegen</h2>
  
      <ol>
        <li>
          Zorg ervoor dat Bluetooth
          en de netwerkverbinding van uw telefoon zijn ingeschakeld.
        </li>
  
        <li>
          Druk eenmaal op de knop
          om de smartcard in te schakelen
          (u hoort een pieptoon).
        </li>
  
        <li>
          Houd de smartcard dicht bij uw Android-apparaat
          en wacht tot de pop-up verschijnt.
          <br />
          <strong>Opmerking:</strong>
          Als er geen pop-up verschijnt,
          start uw telefoon opnieuw op en probeer het opnieuw.
        </li>
  
        <li>
          Tik op “Verbinden”
          en accepteer de meldingen
          om het koppelen te voltooien.
        </li>
  
        <li>
          Selecteer in de app “Google Find Hub”
          de optie “Smartcard”
          om de apparaatnaam en categorie aan te passen.
        </li>
      </ol>
  
      <div class="divider"></div>
  
      <h1>Verloren-modus inschakelen</h1>
  
      <p>
        Open de app “Google Find Hub”,
        selecteer uw smartcard
        en tik op “Markeren als verloren”.
      </p>
  
      <p>
        Voeg uw contactgegevens toe
        en u ontvangt een melding
        wanneer het Find Hub-netwerk
        uw apparaat lokaliseert.
      </p>
  
      <h2>Locatie delen van smartcard</h2>
  
      <p>
        Open de app “Google Find Hub”,
        selecteer uw smartcard
        en tik vervolgens op “Apparaat delen”.
      </p>
  
      <h2>Verbinden met een andere telefoon</h2>
  
      <p>
        Nadat het resetproces is voltooid,
        kunt u de smartcard verbinden
        met een andere Android-telefoon.
      </p>
  
      <div class="divider"></div>
  
      <h1>Opladen</h1>
  
      <p>
        Gebruik standaard draadloze opladers
        om het product draadloos op te laden.
      </p>
  
      <p>
        Het rode lampje brandt tijdens het opladen
        en gaat uit zodra het apparaat volledig is opgeladen.
      </p>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'AndroidCardDutchGuide',
  };
  </script>
  
  <style scoped>
  
  .english-container{
    background-color:#ffffff;
    border-radius:8px;
    padding:30px;
    margin:10px auto;
    max-width:1000px;
    box-shadow:0 2px 8px rgba(0,0,0,0.08);
  }
  
  h1{
    font-size:40px;
    margin-top:10px;
    margin-bottom:20px;
    color:#222;
    text-align:left;
  }
  
  h2{
    font-size:24px;
    margin-top:28px;
    margin-bottom:12px;
    color:#333;
    text-align:left;
  }
  
  p{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:14px;
    text-align:left;
  }
  
  ol{
    padding-left:24px;
    margin-bottom:20px;
  }
  
  li{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:10px;
    text-align:left;
  }
  
  strong{
    color:#222;
  }
  
  .remark{
    font-size:14px;
    color:#666;
    background:#f8f8f8;
    padding:12px 14px;
    border-left:4px solid #ff4fa0;
    border-radius:4px;
  }
  
  .divider{
    width:100%;
    height:1px;
    background:#e5e5e5;
    margin:40px 0;
  }
  
  @media (max-width:768px){
  
    .english-container{
      padding:20px;
    }
  
    h1{
      font-size:30px;
    }
  
    h2{
      font-size:20px;
    }
  
    p, li{
      font-size:14px;
    }
  }
  
  </style>